module.exports = "img/flags/GW.c92da4e.png";